function Error() {
  return (
    <div className="state">
      <p className="error">
        <span>❗</span> There was an error fetching data
      </p>
    </div>
  );
}

export default Error;
